<div class="site-announcement-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'siteAnnouncement.dialog.title' | translate }}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="message" [innerHtml]="message"></div>
    </mat-dialog-content>
</div>
